export const CARD_SERIAL_LENGTH = 16;
const MIN_CARD_SEARCH_LENGTH = 3;

export const normalizeCardSerial = (serial: string): string =>
  serial.replace(/\s+/g, '');

/**
 * Space-stripped digits when the query looks like a card serial. The backend
 * matches on a prefix/infix of the 16-digit number, so 3–16 digits are enough.
 */
export const toCardSearchQuery = (query: string): string | undefined => {
  const normalized = normalizeCardSerial(query.trim());
  return normalized.length >= MIN_CARD_SEARCH_LENGTH &&
    normalized.length <= CARD_SERIAL_LENGTH &&
    /^\d+$/.test(normalized)
    ? normalized
    : undefined;
};

export const getUniqueCardSerials = (
  serials: (string | undefined)[],
): string[] => {
  const unique = new Set<string>();

  for (const serial of serials) {
    const normalized = serial?.trim() ? normalizeCardSerial(serial) : '';
    if (normalized.length >= MIN_CARD_SEARCH_LENGTH) {
      unique.add(normalized);
    }
  }

  return [...unique];
};

export const normalizeCardSerialInput = (raw: string): string =>
  raw.replace(/\D/g, '').slice(0, CARD_SERIAL_LENGTH);

export const formatCardSerial = (serial: string): string =>
  serial.replace(/(\d{4})(?=\d)/g, '$1 ');

interface CardSerialReadyInput {
  serial: string;
  isChecking: boolean;
  isError: boolean;
  claimable?: boolean;
}

export const isCardSerialReady = ({
  serial,
  isChecking,
  isError,
  claimable,
}: CardSerialReadyInput): boolean => {
  if (serial.length === 0) return true;
  if (serial.length !== CARD_SERIAL_LENGTH) return false;
  if (isChecking || isError) return false;
  return claimable === true;
};
